/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Completed_ToastInputs */

const en_media_import_completed_toast = /** @type {(inputs: Media_Import_Completed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media import completed successfully.`)
};

const fr_media_import_completed_toast = /** @type {(inputs: Media_Import_Completed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation des medias terminee avec succes.`)
};

const de_media_import_completed_toast = /** @type {(inputs: Media_Import_Completed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienimport erfolgreich abgeschlossen.`)
};

const it_media_import_completed_toast = /** @type {(inputs: Media_Import_Completed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione dei media completata con successo.`)
};

const ru_media_import_completed_toast = /** @type {(inputs: Media_Import_Completed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт медиафайлов успешно завершен.`)
};

const es_media_import_completed_toast = /** @type {(inputs: Media_Import_Completed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La importación de medios se completó correctamente.`)
};

const zh_cn2_media_import_completed_toast = /** @type {(inputs: Media_Import_Completed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体导入成功完成。`)
};

const ja_media_import_completed_toast = /** @type {(inputs: Media_Import_Completed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアのインポートが正常に完了しました。`)
};

const hi_media_import_completed_toast = /** @type {(inputs: Media_Import_Completed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया का आयात सफलतापूर्वक पूरा हो गया।`)
};

const pt_pt2_media_import_completed_toast = /** @type {(inputs: Media_Import_Completed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de mídia concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Media import completed successfully." |
*
* @param {Media_Import_Completed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_completed_toast = /** @type {((inputs?: Media_Import_Completed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Completed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_completed_toast(inputs)
	if (locale === "de") return de_media_import_completed_toast(inputs)
	if (locale === "it") return it_media_import_completed_toast(inputs)
	if (locale === "ru") return ru_media_import_completed_toast(inputs)
	if (locale === "es") return es_media_import_completed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_completed_toast(inputs)
	if (locale === "ja") return ja_media_import_completed_toast(inputs)
	if (locale === "hi") return hi_media_import_completed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_completed_toast(inputs)
	return en_media_import_completed_toast(inputs)
});